import {TextWithIcon} from '@legit.health/ui';
import {Backdrop as MuiBackdrop, CircularProgress} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function Backdrop() {
  const {t} = useTranslation(['app']);
  return (
    <MuiBackdrop
      sx={{bgcolor: '#fff', minHeight: '100vh', zIndex: (theme) => theme.zIndex.drawer + 1}}
      open
    >
      <TextWithIcon
        sx={{
          color: 'primary.main'
        }}
        iconLeft={<CircularProgress sx={{mr: 1, color: 'primary.main'}} />}
      >
        {t('app:processing')}
      </TextWithIcon>
    </MuiBackdrop>
  );
}
